import {
  forwardRef,
  type AnchorHTMLAttributes,
  type ForwardedRef,
  type ReactNode,
} from 'react'

import { cn } from '@dreamstack/util/src/cn'

type BaseSimpleTextLinkProps = AnchorHTMLAttributes<HTMLAnchorElement>

export type ISimpleTextLink = BaseSimpleTextLinkProps & {
  bold?: boolean
  big?: boolean
  grey?: boolean
  children?: ReactNode
}

const StylableLink = (
  { big, bold, grey, children, ...props }: ISimpleTextLink,
  ref: ForwardedRef<HTMLAnchorElement>
) => (
  <a ref={ref} {...props}>
    {children}
  </a>
)

const ForwardedStylableLink = forwardRef<HTMLAnchorElement, ISimpleTextLink>(
  StylableLink
)

ForwardedStylableLink.displayName = 'StylableLink'

export const SimpleTextLink = forwardRef<HTMLAnchorElement, ISimpleTextLink>(
  ({ big, bold, grey, className, children, ...props }, ref) => {
    const classes = cn(
      'hover:underline font-montserrat cursor-pointer',
      big ? 'text-lg' : 'text-base',
      bold && 'font-semibold',
      grey ? 'text-black' : 'text-accentroAqua-full',
      className
    )

    return (
      <ForwardedStylableLink
        ref={ref}
        className={classes}
        big={big}
        bold={bold}
        grey={grey}
        {...props}
      >
        {children}
      </ForwardedStylableLink>
    )
  }
)

SimpleTextLink.displayName = 'SimpleTextLink'
